import { Fn } from 'src/hooks/locale/utils'

export interface PortfolioStatus {
  readonly value: string
  readonly name: string
}

export const STATUS_OPTIONS = [
  { value: '', label: 'common:all' },
  { value: '0', label: 'portfolio:status_pending' },
  { value: '1', label: 'portfolio:status_evaluated' },
  { value: '2', label: 'portfolio:status_rejected' },
  { value: '3', label: 'portfolio:status_draft' },
] as const

export const getStatusLabel = (t: Fn, value: string): string => {
  switch (value) {
    case '0':
      return t('portfolio:status_pending')
    case '1':
      return t('portfolio:status_evaluated')
    case '2':
      return t('portfolio:status_rejected')
    case '3':
      return t('portfolio:status_draft')
    default:
      return ''
  }
}

export const getStatusColor = (statusObj: PortfolioStatus): string => {
  switch (statusObj.value) {
    case '0':
      return 'text-yellow-600'
    case '1':
      return 'text-green-600'
    case '2':
      return 'text-red-600'
    case '3':
      return 'text-gray-500'
    default:
      return ''
  }
}
